/**
 * 项目名称同步 Hook
 *
 * 职责：
 * 1. 监听项目名称更新事件
 * 2. 自动同步更新本地的项目名称状态
 *
 * 使用场景：
 * - 当其他组件或流式响应更新了项目名称时
 * - 需要保持页面显示的项目名称与最新状态同步
 */
import { useEffect } from 'react';
import { EVT_UPDATE_CURRENT_PROJECT } from '@/constants/event';

interface UseProjectNameSyncParams {
  setProjectName: (name: string) => void;
}

export const useProjectNameSync = ({
  setProjectName,
}: UseProjectNameSyncParams): void => {
  useEffect(() => {
    const handleProjectNameUpdate = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail) {
        const { projectId, updatedData } = customEvent.detail;

        if (projectId) {
          setProjectName(updatedData.name);
        }
      }
    };

    // stream 发起的，无需判断当前 Add event listener
    window.addEventListener(
      EVT_UPDATE_CURRENT_PROJECT,
      handleProjectNameUpdate as EventListener,
    );

    // Cleanup
    return () => {
      window.removeEventListener(
        EVT_UPDATE_CURRENT_PROJECT,
        handleProjectNameUpdate as EventListener,
      );
    };
  }, [setProjectName]);
};
